var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "新增专家信息",
        okText: "确认",
        cancelText: "取消",
        width: "1000px",
        visible: _vm.visible,
        "confirm-loading": _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.formState,
            rules: _vm.rules,
            "label-col": { span: 8 },
            "wrapper-col": { span: 16 },
          },
        },
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "专家姓名",
                        prop: "name",
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: { disabled: this.param.id },
                        model: {
                          value: _vm.formState.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "name", $$v)
                          },
                          expression: "formState.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "所属单位",
                        prop: "gov",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.gov,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "gov", $$v)
                          },
                          expression: "formState.gov",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "职称",
                        prop: "zhicheng",
                      },
                    },
                    [
                      _c("a-ext-local-dic-select", {
                        attrs: { "dic-key": "ZhiCheng" },
                        model: {
                          value: _vm.formState.zhicheng,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "zhicheng", $$v)
                          },
                          expression: "formState.zhicheng",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "角色",
                        prop: "type",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "type", $$v)
                          },
                          expression: "formState.type",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "电话",
                        prop: "tel",
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: { disabled: this.param.id },
                        model: {
                          value: _vm.formState.tel,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "tel", $$v)
                          },
                          expression: "formState.tel",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "所在地",
                        prop: "address",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.address,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "address", $$v)
                          },
                          expression: "formState.address",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              !this.param.id
                ? _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 },
                            label: "账号",
                            prop: "account",
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: this.param.id },
                            model: {
                              value: _vm.formState.account,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "account", $$v)
                              },
                              expression: "formState.account",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !this.param.id
                ? _c(
                    "a-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            labelCol: { span: 8 },
                            wrapperCol: { span: 16 },
                            label: "密码",
                            prop: "pwd",
                          },
                        },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.formState.pwd,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "pwd", $$v)
                              },
                              expression: "formState.pwd",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }